export { ImageTile } from "./image-tile";
export type { ImageTileProps, size } from "./interface";
